import { buttons_close, modal_open_image } from './style'
import styles from './CreateBriefing.module.css'

import { useEffect, useState } from 'react'
import { ListComponents } from '../ListComponents'
import { useComponentContext } from '../../context/ComponentBriefingContextProvider'
import { CreateNewTypeComponent } from '../CreateNewTypeComponent'
import { useClient } from '../../../../contexts/ClientContext'
import attendanceApi from '../../../../services/api/attendance'

import {
  Box,
  Button,
  CircularProgress,
  Divider,
  IconButton,
  Modal,
  TextField,
} from '@mui/material'
import UploadFileIcon from '@mui/icons-material/UploadFile'
import CloseIcon from '@mui/icons-material/Close'
import AddToPhotosIcon from '@mui/icons-material/AddToPhotos'
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf'
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked'
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'
import ExpandLessIcon from '@mui/icons-material/ExpandLess'
import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import { truncateString } from '@/utils/truncateString'
import { StyledQuill } from '../Proposta/quill'
import DOMPurify from 'dompurify'

interface CreateBriefingProps {
  state?: boolean
  // idClient: number
  // idBriefing: number
  idAtendimento: number
  ativo : boolean
}

export function CreateBriefing({ state, idAtendimento, ativo }: CreateBriefingProps) {
  const [spread, setSpread] = useState(ativo)
  const [openMotal, setOpenModal] = useState<boolean>(false)
  const [fileURLs, setFileURLs] = useState<string[]>([])
  const [imgURLs, setImagURLs] = useState<string[]>([])
  const [audioURLs, setAudioURLs] = useState<string[]>([])

  const [images, setImages] = useState<File[]>([])
  const [arquivos, setArquivos] = useState<File[]>([])
  const [audios, setAudios] = useState<File[]>([])
  const [loadingFiles, setLoadingFiles] = useState(false);

  const [showComponentImage, setshowComponentImage] = useState<boolean>(false)
  const [showComponentTitle, setshowComponentTitle] = useState<boolean>(false)
  const [showComponentDescription, setshowComponentDescription] =
    useState<boolean>(false)
  const [showComponentPdfOrWord, setshowComponentPdfOrWord] =
    useState<boolean>(false)
  const [apresentaComponenteAudio, setApresentaComponenteAudio] = useState<boolean>(false)

  const [titulo, setTitulo] = useState<string>()
  const [texto, setTexto] = useState<string>()
  const [tipoComponente, setTipoComponente] = useState<string>()

  const clientContext = useClient()

  const [idBriefing, setIdBriefing] = useState<number>(0)
  const [idClient, setIdClient] = useState<number>(clientContext.client.id ?? 0)

  const { addComponent, components, fetchComponents } = useComponentContext()

  useEffect(() => {
    attendanceApi.getAttendance(idAtendimento).then((response) => {
      if (!response.data.briefingId) {
        console.error('Houve um erro ao obter um atendimento: ' + response)
        return
      }
      setIdBriefing(response.data.briefingId)
      fetchComponents(response.data.briefingId)
    })
    //setIdAttendance(clientContext.client.atendimentoAtualId)
    setIdClient(clientContext.client.id ?? 0)
  }, [idAtendimento])

  // Captura o arquivo(s) selecionado(s) e armazena em um estado do tipo array
  function handleFileChange(event: React.ChangeEvent<HTMLInputElement>) {
    const newFiles = event.target.files

    if (newFiles) {
      const newImages: File[] = []
      const otherFiles: File[] = []
      const arquivoAudio: File[] = []

      for (let i = 0; i < newFiles.length; i++) {
        const file = newFiles[i]
        if (file.type.match('image.*')) {
          newImages.push(file)
        } else if (file.type.match('audio.*') || file.type.match('.ogg') || file.type.match('.mp3') || file.type.match('.wav')) {
          console.log('Audio file detected:', file)
          arquivoAudio.push(file)
        } else if (
          file.type === 'application/pdf' ||
          file.type.match('application/msword') ||
          file.type.match(
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          )
        ) {
          otherFiles.push(file)
        }
      }

      setImages((prevImages) => [...prevImages, ...newImages])
      setArquivos((prevFiles) => [...prevFiles, ...otherFiles])
      setAudios((prevAudios) => [...prevAudios, ...arquivoAudio])
    }
    handleCloseModal()
  }

  // Arrasta e solta a imagem(s) selecion
  function handleDrop(event: React.DragEvent<HTMLLabelElement>) {
    event.preventDefault();
    const files = event.dataTransfer.files;

    const newImages: File[] = [];
    const otherFiles: File[] = [];
    const textFiles: File[] = [];  // Novo array para arquivos de texto
    const arquivoAudio: File[] = []

    for (let i = 0; i < files.length; i++) {
      const file = files[i];

      if (file.type.match('image.*')) {
        newImages.push(file);
      } else if (file.type.match('audio.*') || file.type.match('.ogg') || file.type.match('.mp3') || file.type.match('.wav')) {
        console.log('Audio', file)
        arquivoAudio.push(file)
      } else if (
        file.type === 'application/pdf' ||
        file.type.match('application/msword') ||
        file.type.match('application/vnd.openxmlformats-officedocument.wordprocessingml.document')
      ) {
        otherFiles.push(file);
      } else if (file.type === 'text/plain') {
        textFiles.push(file);
        console.log('Audio', file)
      }
    }

    // Atualiza os estados com os novos arquivos
    setImages((prevImages) => [...prevImages, ...newImages]);
    setArquivos((prevFiles) => [...prevFiles, ...otherFiles]);
    setAudios((prevAudios) => [...prevAudios, ...arquivoAudio]);

    // Processa os arquivos de texto, caso tenha sido arrastado algum
    if (textFiles.length > 0) {
      handleTextFiles(textFiles);
    }

    handleCloseModal();
  }

  function handleTextFiles(files: File[]) {
    files.forEach((file) => {
      const reader = new FileReader();
      reader.onload = (event) => {
        const content = event.target?.result as string;
        const formattedContent = content.replace(/(\r\n|\r|\n)/g, '\n');
        setTexto((prevText) => (prevText ? `${prevText}\n${formattedContent}` : formattedContent));
      };
      reader.readAsText(file);
    });
  }

  // SUBMIT API
  function handleSubmitTitle(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    event.stopPropagation()

    console.log('idBriefing: ', idBriefing)

    addComponent(
      idClient,
      idBriefing,
      idAtendimento,
      titulo,
      tipoComponente,
      images
    )
    resetTitle()
  }

  function handleSubmitText(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    event.stopPropagation()

    addComponent(
      idClient,
      idBriefing,
      idAtendimento,
      texto,
      tipoComponente,
      images
    )
    resetText()
  }

  async function handleSubmitImage(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    event.stopPropagation()
    setLoadingFiles(true);

    console.log(images)
    try {
      await addComponent(idClient, idBriefing, idAtendimento, '', 'img', images);
      resetImage();
    } finally {
      setLoadingFiles(false);
    }
  }

  async function handleSubmitFiles(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    event.stopPropagation()

    try {
      await addComponent(idClient, idBriefing, idAtendimento, '', 'pdf', arquivos);
      resetPdfOrWord();
    } finally {
      setLoadingFiles(false);
    }
  }

  async function submeterAudio(event: React.FormEvent<HTMLFormElement>) {
    event.preventDefault()
    event.stopPropagation()
    try {
      await addComponent(idClient, idBriefing, idAtendimento, '', 'audio', audios);
      resetaAudio();
    } finally {
      setLoadingFiles(false);
    }
  }


  function resetTitle() {
    setTitulo('')
    setshowComponentTitle(false)
  }

  function resetText() {
    setTexto('')
    setshowComponentDescription(false)
  }

  function resetImage() {
    setImages([])
    setshowComponentImage(false)
  }

  function resetPdfOrWord() {
    setArquivos([])
    setshowComponentPdfOrWord(false)
  }

  function resetaAudio() {
    setAudios([])
    setApresentaComponenteAudio(false)
  }

  function togglspread() {
    setSpread(!spread)
    console.log('Atendance: ', idAtendimento)
  }

  useEffect(() => {
    resetTitle()
    resetText()
    resetImage()
    resetPdfOrWord()
  }, [idBriefing])

  useEffect(() => {
    console.log('idBriefing... ', idBriefing)
  })

  useEffect(() => { }, [components])

  useEffect(() => {
    // Criar URLs de pré-visualização para imagens
    const newImgURLs = images.map((file) => URL.createObjectURL(file))
    setImagURLs(newImgURLs)

    // Criar URLs de pré-visualização para outros arquivos
    const newFileURLs = arquivos.map((file) => URL.createObjectURL(file))
    setFileURLs(newFileURLs)

    // Criar URLs de pré-visualização para outros audios
    const newAudioURLs = audios.map((file) => URL.createObjectURL(file))
    setAudioURLs(newAudioURLs)

    // Limpeza das URLs ao desmontar o componente
    return () => {
      newImgURLs.forEach(URL.revokeObjectURL)
      newFileURLs.forEach(URL.revokeObjectURL)
      newAudioURLs.forEach(URL.revokeObjectURL)
    }
  }, [images, arquivos, audios])

  function handleDragOver(event: React.DragEvent<HTMLLabelElement>) {
    event.preventDefault()
  }

  function handleClickCreateTitle(tipo: string) {
    setshowComponentTitle((prev) => !prev)
    setTipoComponente(tipo)
  }

  function handleClickCreateDescription(tipo: string) {
    setshowComponentDescription((prev) => !prev)
    setTipoComponente(tipo)
  }

  function handleClickUploadImage(tipo: string) {
    setshowComponentImage((prev) => !prev)
    setTipoComponente(tipo)
    handleOpenModal()
  }

  function handleClickUploadPdfOrWord(tipo: string) {
    setshowComponentPdfOrWord((prev) => !prev)
    setTipoComponente(tipo)
    handleOpenModal()
  }

  function lidarComClickEnvioAudio(tipo: string) {
    setApresentaComponenteAudio((prev) => !prev)
    setTipoComponente(tipo)
    handleOpenModal()
  }

  function handleCloseModal() {
    setOpenModal(false)
  }

  function handleOpenModal() {
    setOpenModal(true)
  }

  function handlePaste(event: React.ClipboardEvent<HTMLInputElement | HTMLTextAreaElement>) {
    event.preventDefault();

    const pastedText = event.clipboardData.getData("text");
    const target = event.target as HTMLInputElement | HTMLTextAreaElement;
    const { selectionStart, selectionEnd } = target;

    setTexto((prevText) => {
        if (selectionStart !== null && selectionEnd !== null) {
            return (
                (prevText?.slice(0, selectionStart) || '') +
                pastedText +
                (prevText?.slice(selectionEnd) || '')
            );
        }
        return prevText + pastedText;
    });
  }

  console.log(audioURLs, audios)

  return (
    <>
      {spread ? (
        <>
          <>
            <div className={styles.container_header}>
              <div className={styles.icon_and_title}>
                {state ? (
                  <CheckCircleIcon className={styles.checked_briefing} />
                ) : (
                  <RadioButtonUncheckedIcon
                    className={styles.unchecked_briefing}
                  />
                )}

                <h4>Briefing</h4>
              </div>

              <div className={styles.open_for_close}>
                <IconButton onClick={togglspread}>
                  <ExpandLessIcon fontSize='large' />
                </IconButton>
              </div>
            </div>

            <Divider component='li' style={{ listStyle: 'none', marginBottom: '1rem' }} />
          </>

          <ListComponents
            idBriefing={idBriefing}
            idClient={idClient}
            idAttendance={idAtendimento}
          />

          {showComponentTitle && (
            <form
              className={styles.form_create_briefing}
              onSubmit={handleSubmitTitle}
            >
              <div className={styles.create_component}></div>
              <div className={styles.component_title}>
                <TextField
                  className={styles.title}
                  fullWidth
                  label='Título'
                  placeholder='Insira o título...'
                  name='titulo'
                  value={titulo}
                  onChange={(e) => setTitulo(e.target.value)}
                  inputProps={{ maxLength: 150 }}
                />

                <div className={styles.footer_button}>
                  <Button type='submit' variant='contained'>
                    Salvar
                  </Button>
                </div>
              </div>
            </form>
          )}

          {showComponentDescription && (
            <form onSubmit={handleSubmitText} className={styles.form_briefing}>
              <div className={styles.container_component_text}>
                <StyledQuill
                  theme="snow"
                  value={DOMPurify.sanitize(texto ?? "")}
                  onChange={(e) => {
                    setTexto(e)
                  }}
                  style={{ width: '100%' }}
                  placeholder='Insira o texto aqui...'
                />

                <div className={styles.footer_button}>
                  <Button type='submit' variant='contained'>
                    Salvar
                  </Button>
                </div>
              </div>
            </form>
          )}

          {showComponentImage && (
            <form onSubmit={handleSubmitImage}>
              <div className={styles.update_component_image}>
                <div className={styles.upload_images}>
                  <Modal
                    open={openMotal}
                    onClose={handleCloseModal}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                  >
                    <Box sx={modal_open_image}>
                      <label
                        htmlFor='img-upload'
                        className={styles.drag_and_drop_area}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDrop={handleDrop}
                      >
                        <div className={styles.description_title}>
                          <span>Selecione ou arraste seu arquivo</span>
                          <span>Imagens</span>
                        </div>

                        <UploadFileIcon fontSize='large' />
                        <input
                          id='img-upload'
                          type='file'
                          accept='image/jpeg, image/png, image/gif'
                          hidden
                          multiple
                          onChange={handleFileChange}
                        />
                      </label>

                      <IconButton sx={buttons_close} onClick={handleCloseModal}>
                        <CloseIcon fontSize='large' />
                      </IconButton>
                    </Box>
                  </Modal>

                  <div className={styles.images_component}>
                    {imgURLs.map((img, index) => (
                      <>
                        <img key={index} src={img}></img>
                      </>
                    ))}
                    {imgURLs.length > 0 ? (
                      <IconButton onClick={handleOpenModal}>
                        <AddToPhotosIcon />
                      </IconButton>
                    ) : (
                      <label
                        className={styles.drag_and_drop_add}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDrop={handleDrop}
                        onClick={handleOpenModal}
                      >
                        Selecionar imagem
                        <UploadFileIcon fontSize='medium' />
                      </label>
                    )}
                  </div>
                </div>

                <div className={styles.footer_button}>
                  <Button type='submit' variant='contained'>
                    {loadingFiles ? <CircularProgress size={24} sx={{ color: 'white' }} /> : <></>}
                    Salvar
                  </Button>
                </div>
              </div>
            </form>
          )}

          {showComponentPdfOrWord && (
            <form onSubmit={handleSubmitFiles}>
              <div className={styles.update_component_image}>
                <div className={styles.upload_images}>
                  <Modal
                    open={openMotal}
                    onClose={handleCloseModal}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                  >
                    <Box sx={modal_open_image}>
                      <label
                        htmlFor='file-upload'
                        className={styles.drag_and_drop_area}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDrop={handleDrop}
                      >
                        <div className={styles.description_title}>
                          <span>Selecione ou arraste seu arquivo</span>
                          <span>PDFs ou Word</span>
                        </div>

                        <UploadFileIcon fontSize='large' />
                        <input
                          id='file-upload'
                          type='file'
                          accept='application/pdf, application/msword, application/vnd.openxmlformats-officedocument.wordprocessingml.document'
                          hidden
                          multiple
                          onChange={handleFileChange}
                        />
                      </label>

                      <IconButton sx={buttons_close} onClick={handleCloseModal}>
                        <CloseIcon fontSize='large' />
                      </IconButton>
                    </Box>
                  </Modal>

                  <div className={styles.pdf_component}>
                    {arquivos.map((file, index) => (
                      <>
                        <a
                          href={fileURLs[index]}
                          target='_blank'
                          className={styles.file_pdf}
                        >
                          <PictureAsPdfIcon />
                          {truncateString(file.name, 12)}
                        </a>
                      </>
                    ))}
                    {fileURLs.length > 0 ? (
                      <IconButton onClick={handleOpenModal}>
                        <AddToPhotosIcon />
                      </IconButton>
                    ) : (
                      <label
                        className={styles.drag_and_drop_add}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDrop={handleDrop}
                        onClick={handleOpenModal}
                      >
                        Selecionar documentos
                        <UploadFileIcon fontSize='medium' />
                      </label>
                    )}
                  </div>
                </div>

                <div className={styles.footer_button}>
                  <Button type='submit' variant='contained'>
                    {loadingFiles ? <CircularProgress size={24} sx={{ color: 'white' }} /> : <></>}
                    Salvar
                  </Button>
                </div>
              </div>
            </form>
          )}

          {apresentaComponenteAudio && (
            <form onSubmit={submeterAudio}>
              <div className={styles.update_component_image}>
                <div className={styles.upload_images}>
                  <Modal
                    open={openMotal}
                    onClose={handleCloseModal}
                    aria-labelledby='modal-modal-title'
                    aria-describedby='modal-modal-description'
                  >
                    <Box sx={modal_open_image}>
                      <label
                        htmlFor='file-upload'
                        className={styles.drag_and_drop_area}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDrop={handleDrop}
                      >
                        <div className={styles.description_title}>
                          <span>Selecione ou arraste seu arquivo</span>
                          <span>Áudio</span>
                        </div>

                        <UploadFileIcon fontSize='large' />
                        <input
                          id='file-upload'
                          type='file'
                          accept='audio/*, .mp3, .wav, .ogg'
                          hidden
                          multiple
                          onChange={handleFileChange}
                        />
                      </label>

                      <IconButton sx={buttons_close} onClick={handleCloseModal}>
                        <CloseIcon fontSize='large' />
                      </IconButton>
                    </Box>
                  </Modal>

                  <div className={styles.pdf_component}>
                    {audios.map((file, index) => (
                      <>
                        <audio src={audioURLs[index]} controls >
                          Seu navegador não suporta o elemento de áudio
                        </audio>
                      </>
                    ))}
                    {audioURLs.length > 0 ? (
                      <IconButton onClick={handleOpenModal}>
                        <AddToPhotosIcon />
                      </IconButton>
                    ) : (
                      <label
                        className={styles.drag_and_drop_add}
                        onDragOver={handleDragOver}
                        onDragEnter={handleDragOver}
                        onDrop={handleDrop}
                        onClick={handleOpenModal}
                      >
                        Selecionar áudio
                        <UploadFileIcon fontSize='medium' />
                      </label>
                    )}
                  </div>
                </div>

                <div className={styles.footer_button}>
                  <Button type='submit' variant='contained'>
                    {loadingFiles ? <CircularProgress size={24} sx={{ color: 'white' }} /> : <></>}
                    Salvar
                  </Button>
                </div>
              </div>
            </form>
          )}
          <CreateNewTypeComponent
            onCreateTitle={() => handleClickCreateTitle('titulo')}
            onCreateDescription={() => handleClickCreateDescription('texto')}
            onUploadImageClick={() => handleClickUploadImage('img')}
            onUploadPdfOrWord={() => handleClickUploadPdfOrWord('pdf')}
            enviarAudio={() => lidarComClickEnvioAudio('audio')}
            existeComponente={components.length > 0}
          />
        </>
      ) : (
        <>
          <div className={styles.container_header}>
            <div className={styles.icon_and_title}>
              {state ? (
                <CheckCircleIcon className={styles.checked_briefing} />
              ) : (
                <RadioButtonUncheckedIcon
                  className={styles.unchecked_briefing}
                />
              )}

              <h4>Briefing</h4>
            </div>

            <div className={styles.open_for_close}>
              <IconButton onClick={togglspread}>
                <ExpandMoreIcon fontSize='large' />
              </IconButton>
            </div>
          </div>

          <Divider component='li' style={{ listStyle: 'none' }} />
        </>
      )}
    </>
  )
}